import PropTypes from 'prop-types'

const CollectionList = ({ children }) => <div className={`ctp-collection-list`}>{children}</div>

CollectionList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
}

export default CollectionList
